var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PendingUserForms',{attrs:{"title":_vm.$t('table.pendingForms'),"items":_vm.pendingForms,"loading":_vm.loading}}),_c('HistoricUserForms',{staticClass:"mt-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }